import React, { useEffect, useState } from 'react';
//import { Link } from "react-router";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from "react-redux";
import { setLoginState, logout } from "../../redux/authSlice";
import MeetingCalendar from "../calendar/MeetingCalendar";
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner'; // <-- Import Spinner
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import MemberAttendance from '../member/MemberAttendance';
import MemberFutureMeetingsSelector from '../member/MemberFutureMeetingsSelector';
import MemberApologyForm from '../member/MemberApologyForm';
import MemberTrainingList from '../membertraining/MemberTrainingList';
import {
    format,
    subYears
} from 'date-fns';
import MemberNewsFeed from '../membernews/MemberNewsFeed';
import FormSubmission from '../forms/FormSubmission';
import FormSubmissionsList from '../forms/FormSubmissionsList';
/**
 * MembersAreaDashboard
 * Dashboard component for the members area.
 */
const MembersAreaDashboard = () => {
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const member = useSelector(state => state.auth.user ? state.auth.user : null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedtab, setSelectedTab] = useState("home")
    const [futureMeetings, setFutureMeetings] = useState([]);
    const [memberForms, setMemberForms] = useState([]);
    // new state: token to trigger refresh of FormSubmissionsList when a submission occurs
    const [formSubmissionsRefresh, setFormSubmissionsRefresh] = useState(0);
    async function updatereduxloginstate() {
        const res = await axios.get(authConfig.api.urls.getAuthStatus, { withCredentials: true })
        if (res && res.data.isAuthenticated) {
            dispatch(setLoginState({
                isLoggedIn: true,
                user: {
                    username: res.data.username,
                    memberId: res.data.memberId,
                    fullname: res.data.fullname,
                    roles: res.data.roles,
                }
            }));
        } else {
            dispatch(setLoginState({ isLoggedIn: false, user: null }));
        }
    }

    useEffect(() => {
        const fetchMeetings = async () => {
            //setLoading(true);
            try {
                const response = await fetch(authConfig.api.urls.getMemberFutureMeetingsList, {
                    credentials: 'include',
                });
                const data = await response.json();
                // Map API data to expected format
                const meetings = data.map(m => ({
                    id: m.id,
                    title: m.meeting.titleEn,
                    committee: m.committee.nameEn,
                    date: m.start,
                }));
                setFutureMeetings(meetings);
            } catch (error) {
                setFutureMeetings([]);
            }
            //setLoading(false);
        };
        const fetchForms = async () => {
            //setLoading(true);
            try {
                const response = await fetch(authConfig.api.urls.getMemberFormListForMember, {
                    credentials: 'include',
                });
                const data = await response.json();
                // Map API data to expected format
                //const meetings = data.map(m => ({
                //    id: m.id,
                //    title: m.meeting.titleEn,
                //    committee: m.committee.nameEn,
                //    date: m.start,
                //}));
                setMemberForms(data);
            } catch (error) {
                setFutureMeetings([]);
            }
            //setLoading(false);
        };
        fetchMeetings();
        fetchForms();
    }, []);
    useEffect(() => {
        updatereduxloginstate();
        //setLoading(false);
    }, [dispatch]);
    useEffect(() => {
        if (isLoggedIn) {
            //navigate("/"); // Change "/" to your desired redirect route
        }
    }, [isLoggedIn, navigate]);

    const handleTabSelect = (e) => {
        setSelectedTab(e);
        console.log(e);
    }

    
    return member && member.memberId ? (
        <Container>
            {/* TODO: Add dashboard widgets and member-specific content here */}

            <Card bg="" className="membercard">
                <Card.Header>
                    <h2>{member.fullname} Dashboard</h2>
                    <Nav className="membersnav" variant="tabs" activeKey={selectedtab} onSelect={handleTabSelect}>
                        <Nav.Item >
                            <Nav.Link eventKey="home" >Home</Nav.Link>
                        </Nav.Item>
                        <Nav.Item >
                            <Nav.Link eventKey="calendar" >Calendar</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="forms" >Forms</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="training">Training Materials</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
                {selectedtab === "home" ? (
                    <Card.Body>
                        <Row xs={1} md={2}>
                            <Col>
                                <Card>
                                    <Card.Header>Upcoming Meetings</Card.Header>
                                    <Card.Body>
                                        {futureMeetings.map((o,index) => (
                                            <Row style={{ backgroundColor: index % 2 ? "#EEEEEE" : "#FFFFFF"} }>
                                                <Col xs="4">{format( new Date(o.date), "dd/MM/yy HH:mm") }</Col>
                                                <Col xs="8">
                                                    <Link to={"/meeting/" + o.id}>
                                                        {o.title}
                                                    </Link>
                                                </Col>
                                                <Col></Col>
                                            </Row>

                                        ))}
                                        <br/>
                                        <MemberApologyForm memberId={member.memberId} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>News</Card.Header>
                                    <Card.Body>
                                        <MemberNewsFeed />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>Forms</Card.Header>
                                    <Card.Body>
                                        <FormSubmission onSubmit={() => setFormSubmissionsRefresh(prev => prev +1)} />
                                        
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>Attendance</Card.Header>
                                    <Card.Body>
                                        <MemberAttendance memberId={member.memberId}
                                            from={format(subYears(new Date(), 1), 'yyyy-MM-dd')}
                                            to={format(new Date(), 'yyyy-MM-dd')} withbreakdown={false}>
                                        </MemberAttendance>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                ) : ""}
                {selectedtab === "calendar" ? (
                    <Card.Body>
                        <Card.Title></Card.Title>
                        <Card.Text>
                            <MeetingCalendar onClick={(meeting) => {
                                console.log(meeting);
                                navigate("/meeting/" + meeting.id);
                            }} memberId={member.memberId}></MeetingCalendar>
                        </Card.Text>
                    </Card.Body>
                ) : ""}
                {selectedtab === "forms" ? (
                    <Card.Body>
                        <Card>
                            <Card.Header>Forms</Card.Header>
                            <Card.Body>
                                <FormSubmission onSubmit={() => setFormSubmissionsRefresh(prev => prev +1)} />
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Header>My Submissions</Card.Header>
                            <Card.Body>
                                <FormSubmissionsList refreshData={formSubmissionsRefresh} />
                            </Card.Body>
                        </Card>
                    </Card.Body>

                ) : ""}
                {selectedtab === "training" ? (
                    <Card.Body>
                        <MemberTrainingList />
                    </Card.Body>
                ) : ""}

            </Card>

        </Container>
    ) : (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </Container>
    );
};

export default MembersAreaDashboard;